import translationService from "./TranslationService";
import internalStateService from "./InternalStateService";

const messageTypeTitleId = {
    error: "errorGroupLabel",
    success: "successGroupLabel",
    warning: "warningGroupLabel",
    info: "infoGroupLabel",
    neutral: "neutralGroupLabel"
};
const messageDefault = {
    type: "info",
    title: translationService.translate("dialogTitleAttention"),
    message: ""
};

const actionButtonsDefaultLabels = [
    {
        id: "confirmButton",
        label: translationService.translate("yes")
    },
    {
        id: "cancelButton",
        label: translationService.translate("no")
    }
];

// const escapeRegExp = function (str) {
//     return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
// };

// notifications: {
//     beforeExitFlowMessage": {
//     "type": "info",
//         "title": "Atention",
//         "message": "En poursuivant, toutes les données déjà saisies seront sauvegardées et vous pourrez y accéder plus tard. Êtes-vous certain de vouloir quitter la saisie ?",
//         "actions": [
//         {
//             "label": "Ok",
//             "icon": "tq-icon-ok",
//             "id": "confirm"
//         },
//         {
//             "label": "Cancel",
//             "icon": "tq-icon-cancel",
//             "id": "cancel"
//         }
//     ]
// }
// }
function getNotificationMessage(state = {}, messageId, language) {
    if (!language) {
        language = internalStateService.getGlobalProperty("locale");
    }
    //get application messages from the store
    //let configuredMessages = internalStateService.getGlobalConfigProperty("messages");
    let configuredMessages = state["messages"];
    if (!configuredMessages) {
        return "";
    }
    let notificationMessages = configuredMessages.notifications || {};
    let messageTemplate = notificationMessages[messageId] || {};
    //merge properties to have default behavior
    let aggregatedMessage = Object.assign(messageDefault, messageTemplate);
    //manage info messages with confirm and cancel button
    if (aggregatedMessage.type === "info" && !aggregatedMessage.hasOwnProperty("actions")) {
        aggregatedMessage.actions = [actionButtonsDefaultLabels];
    }
    //title
    if (!aggregatedMessage.title) {
        let defaultTitleId = messageTypeTitleId[aggregatedMessage.type];
        aggregatedMessage.title = translationService.translate(defaultTitleId, language);
    }

    return aggregatedMessage;
}

function getValidationMessage(messageId, dataProperties = {}, language) {
    //TODO - to access global redux store
    // const state = internalStateService.getActionByName("application.getStoreByName")("global");
    // let validationMessages = state.getIn(["messages", "validations"]);
    // if (validationMessages[messageId]) {
    //     let patternMatch = validationMessages[messageId].match(/\${(.*)}/);
    //     if (patternMatch) {
    //         let dataAttribute = patternMatch.pop();
    //
    //         let placeholder = "${" + patternMatch[0] + "}";
    //         return validationMessages[messageId].replace(
    //             new RegExp(escapeRegExp(placeholder), "g"),
    //             dataProperties[dataAttribute]
    //         );
    //     }
    //     return validationMessages[messageId];
    // }
    if (!language) {
        language = internalStateService.getGlobalProperty("locale");
    }
    return translationService.translate(messageId, language);
}

function getRequiredMessage(dataProperties = {}, language) {
    if (!language) {
        language = internalStateService.getGlobalProperty("locale");
    }
    //requiredPattern: "${label} - message"
    return getValidationMessage("requiredMessage", dataProperties, language);
}

export default {
    getNotificationMessage,
    getValidationMessage,
    getRequiredMessage
};
